export default class GravatarService {
  /* @ngInject */
  constructor(md5) {
    this.md5 = md5;
  }

  getGravatarPicture(email, defaultPictureUrl) {
    if (!defaultPictureUrl)
      defaultPictureUrl = "https://app.quoters.io/img/quotermaster-128.png";
    return (
      "https://www.gravatar.com/avatar/" +
      this.md5.createHash(email) +
      "?d=" +
      encodeURIComponent(defaultPictureUrl)
    );
  }
}
